import { render } from "./EditorWrapper.vue?vue&type=template&id=1d38fbc0"
import script from "./EditorWrapper.vue?vue&type=script&lang=js"
export * from "./EditorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__